import type { enBranding } from '../en/branding';

/** Back office — merek tenant dan domain sendiri (ADR-0036). */
export const idBranding: Record<keyof typeof enBranding, string> = {
  'bo.nav.branding': 'Merek',
  'error.platformMfaRequired':
    'Aktifkan aplikasi autentikator di menu Akun sebelum memakai konsol platform.',
  'bo.branding.title': 'Merek',
  'bo.branding.subtitle': 'Nama dan logo usaha Anda di struk dan menu QR tamu.',
  'bo.branding.readOnly': 'Hanya pemilik atau administrator yang dapat mengubah merek.',
  'bo.branding.cardTitle': 'Struk dan menu',
  'bo.branding.cardDesc': 'Kosongkan kolom untuk hanya memakai nama cabang.',
  'bo.branding.displayName': 'Nama usaha',
  'bo.branding.displayNameHint': 'Tampil di atas nama cabang, mis. “Warung Nusantara”.',
  'bo.branding.logoUrl': 'URL logo',
  'bo.branding.logoUrlHint': 'Tautan HTTPS ke gambar persegi. Tampil di menu tamu.',
  'bo.branding.logoInvalid': 'Masukkan tautan yang diawali https://',
  'bo.branding.receiptHeader': 'Kepala struk',
  'bo.branding.receiptHeaderHint': 'mis. alamat, telepon, atau NPWP. Maksimal 300 karakter.',
  'bo.branding.receiptFooter': 'Kaki struk',
  'bo.branding.receiptFooterHint': 'mis. kata sandi Wi-Fi atau ucapan terima kasih.',
  'bo.branding.tooLong': 'Maksimal {max} karakter.',
  'bo.branding.submit': 'Simpan merek',
  'bo.branding.saved': 'Merek disimpan.',
  'bo.branding.conflict':
    'Merek baru saja diubah orang lain. Versi terbaru ditampilkan; periksa lalu simpan lagi.',
  'bo.branding.domain.title': 'Domain sendiri untuk menu tamu',
  'bo.branding.domain.desc':
    'Tamu membuka menu QR di alamat Anda sendiri, mis. menu.restoranku.id.',
  'bo.branding.domain.notInPlan': 'Domain sendiri tersedia di paket Enterprise.',
  'bo.branding.domain.hostname': 'Domain',
  'bo.branding.domain.request': 'Hubungkan domain',
  'bo.branding.domain.requested': 'Domain terdaftar. Tambahkan catatan DNS di bawah.',
  'bo.branding.domain.check': 'Periksa status',
  'bo.branding.domain.remove': 'Hapus domain',
  'bo.branding.domain.removed': 'Domain dihapus.',
  'bo.branding.domain.dns':
    'Di penyedia DNS Anda, tambahkan catatan CNAME untuk {hostname} yang mengarah ke {target}. Sertifikat terbit otomatis setelah catatan terlihat (biasanya dalam satu jam).',
  'bo.branding.domain.status.none': 'Belum terhubung',
  'bo.branding.domain.status.pending': 'Menunggu DNS',
  'bo.branding.domain.status.active': 'Aktif',
  'bo.branding.domain.status.failed': 'Gagal',
};
